<template>
  <div class="new_vip">
    <div class="content">
      <shop-list :fromPage="'vip'"></shop-list>
    </div>
  </div>
</template>
<script>
import ShopList from "@/views/apply/storeManage/storeList"
export default {
  components: {
    ShopList
  },
  data() {
    return{
    }
  }
};
</script>
<style lang="scss" scoped>
.new_vip{
  padding: 10px 15px;
  height: 100%;
  background: #f1f2f6;
  .content{
    background: #fff;
    overflow: auto;
    height: 100%;
  }
}
</style>
